<mat-expansion-panel
    class="light-flex-card"
    (click)="handleContractCommentSubscription()"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
        <mat-panel-title class="sub-title">Commentaires</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="header-item-filters">
        <app-date-range-picker
            *ngIf="panelOpenState"
            (click)="$event.stopPropagation()"
            [screenFilterForm]="screenFilterForm"
            [styleType]="'squared'"
            [showFloatLabel]="true">
        </app-date-range-picker>

        <div class="comment-actions">
            <div class="tv-round-input-extensible-no-label full-300px">
                <mat-form-field *ngIf="panelOpenState" (click)="$event.stopPropagation()">
                    <mat-label>Chercher</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput name="search" [formControl]="searchFormControl" />
                </mat-form-field>
            </div>

            <button
                *ngIf="panelOpenState"
                class="tv-round-icon-button-icon-small-light-blue add"
                aria-label="add button"
                (click)="$event.stopPropagation(); openAddDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <div class="comment-container">
        <div *ngIf="commentIsEmpty" class="no-comments">Aucun commentaire pour le moment.</div>

        <div class="comment-card-container">
            <div *ngFor="let comment of filteredComments" class="comment-card">
                <div class="card-content">
                    <div class="mat-card-header">
                        <div class="comment-left">
                            <span
                                class="comment-type-badge"
                                [ngClass]="{
                                    classic: comment.type === 1,
                                    digital: comment.type === 2,
                                    parrainage: comment.type === 3,
                                    unknown: !comment.type
                                }">
                                {{ commentTypeLabel[comment.type] || 'Type inconnu' }}
                            </span>

                            <ng-container *ngIf="comment.editedBy && comment.editedAt; else normalMeta">
                                Modifié le {{ comment.editedAt | date : 'dd/MM/yyyy' }} par
                                {{ comment.editedBy }}
                            </ng-container>

                            <ng-template #normalMeta>
                                <span class="author">{{ comment.author }}</span>
                                <p class="comment-date">
                                    {{ comment.commentDate | date : 'dd/MM/yyyy' }}
                                </p>
                            </ng-template>
                        </div>

                        <div class="comment-right">
                            <div class="action-buttons">
                                <button class="tv-round-icon-button-icon-medium-light-blue" (click)="openEditDialog(comment)">
                                    <mat-icon svgIcon="edit"></mat-icon>
                                </button>
                                <button class="tv-round-icon-button-icon-medium-light-blue" (click)="deleteComment(comment.id)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="tv-ns-custom-horizontal-divider"></div>

                    <p class="body">{{ comment.body }}</p>
                </div>
            </div>
        </div>
    </div>
</mat-expansion-panel>
